import { useCallback, useReducer } from "react";

const initialHistory = (initialScript) => {
  const value = typeof initialScript === "function" ? initialScript() : initialScript;
  return { scripts: [typeof value === "string" ? value : ""], index: 0 };
};

function historyReducer(state, action) {
  switch (action.type) {
    case "edit": {
      const script = typeof action.value === "function"
        ? action.value(state.scripts[state.index])
        : action.value;
      const scripts = [...state.scripts];
      scripts[state.index] = script;
      return { ...state, scripts };
    }
    case "generate": {
      if (typeof action.script !== "string" || !action.script.trim()) return state;
      // The empty editor is not a generated version. Preserve an existing draft
      // and append every successful generation in chronological order.
      const scripts = state.scripts.length === 1 && !state.scripts[0].trim()
        ? [action.script]
        : [...state.scripts, action.script];
      return { scripts, index: scripts.length - 1 };
    }
    case "previous":
      return { ...state, index: Math.max(0, state.index - 1) };
    case "next":
      return { ...state, index: Math.min(state.scripts.length - 1, state.index + 1) };
    case "reset":
      return initialHistory("");
    default:
      return state;
  }
}

export default function useScriptHistory(initialScript = "") {
  const [state, dispatch] = useReducer(historyReducer, initialScript, initialHistory);
  const setScript = useCallback((value) => dispatch({ type: "edit", value }), []);
  const addGeneratedScript = useCallback((script) => dispatch({ type: "generate", script }), []);
  const goToPreviousScript = useCallback(() => dispatch({ type: "previous" }), []);
  const goToNextScript = useCallback(() => dispatch({ type: "next" }), []);
  const resetScriptHistory = useCallback(() => dispatch({ type: "reset" }), []);

  return {
    script: state.scripts[state.index],
    setScript,
    addGeneratedScript,
    currentScriptNumber: state.index + 1,
    scriptCount: state.scripts.length,
    goToPreviousScript,
    goToNextScript,
    resetScriptHistory,
  };
}
